import { createResourceLocatorString } from './routes';
import { isUserAuthorized } from './userHelpers';

/**
 * Build return path for post-login redirect (AuthenticationPage reads location.state.from).
 */
export const returnPathFromLocation = location => {
  if (!location) {
    return null;
  }
  return `${location.pathname}${location.search || ''}${location.hash || ''}`;
};

/**
 * Redirect guest to login/signup and return to the current page after auth.
 * @deprecated Prefer requestProgressiveAuth for in-flow onboarding.
 */
export const pushAuthWithReturnTo = (history, routes, location, { routeName = 'LoginPage' } = {}) => {
  const from = returnPathFromLocation(location);
  history.push(createResourceLocatorString(routeName, routes, {}, {}), from ? { from } : undefined);
};

/** Guest or not yet approved — cannot start inquiries/transactions. */
export const needsAuthForMarketplaceAction = currentUser =>
  !currentUser?.id || !isUserAuthorized(currentUser);

let progressiveAuthBridge = null;

/** Wired by ProgressiveAuthProvider on mount. */
export const bindProgressiveAuthBridge = fn => {
  progressiveAuthBridge = fn;
};

/**
 * Open in-flow auth modal when possible; fall back to full-page signup redirect.
 */
export const requestProgressiveAuth = async ({
  history,
  routes,
  location,
  intent = 'general',
  userType = null,
  onAuthenticated,
}) => {
  const returnTo = returnPathFromLocation(location);

  if (progressiveAuthBridge) {
    return progressiveAuthBridge({
      intent,
      userType,
      returnTo,
      onAuthenticated,
    });
  }

  pushAuthWithReturnTo(history, routes, location, { routeName: 'SignupPage' });
  return false;
};
